import { render, staticRenderFns } from "./TeamChanges.vue?vue&type=template&id=1b7a3238&scoped=true"
import script from "./TeamChanges.vue?vue&type=script&lang=js"
export * from "./TeamChanges.vue?vue&type=script&lang=js"
import style0 from "./TeamChanges.vue?vue&type=style&index=0&id=1b7a3238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7a3238",
  null
  
)

export default component.exports